import { useState } from "react";
import dayjs, { Dayjs } from "dayjs";

export function useRepresentmentStartDate() {
  const [value, setValue] = useState<Dayjs | null>(dayjs());

  return {
    value,
    setValue,
    reset: () => setValue(dayjs()),
    invalid: !value?.isValid(),
    payload: value?.isValid() ? { representmentStartDate: value.format("YYYY-MM-DD") } : {},
  };
}
